import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';

import { IRedRakeServerGame, IRedRakeGetUrl, IRedRakeServerGameList } from '../../types/interfaces/Slots/RedRake';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { formatGameId, getTab } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IRedRakeServerGameList>): ISlotViewItem[] =>
    data.map(({ game }: IRedRakeServerGame) => ({
      id: formatGameId(game.gameId.toString()),
      gameId: formatGameId(game.gameId.toString()),
      description: game.description.en,
      gameName: game.gameName.en,
      routeProvider: 'redrake',
      provider: 'redrake',
      tab: getTab(formatGameId(game.gameId.toString())),
      imageUrl: game.imageUrl.en || '',
      type: CasinoType.slots,
    }));

  convertGameUrl = ({ data }: IRedRakeGetUrl) => data.frame_url;
}
export default Converter;
